import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';
import {
  Accordion,
  AccordionItem,
  AccordionItemButton,
  AccordionItemHeading,
  AccordionItemPanel,
} from 'react-accessible-accordion';

export const Wrapper = styled.section`
  display: flex;
  align-items: center;
  max-width: 100%;
  width: 100%;
  margin: 0 auto 1.5rem;
  position: relative;
  padding: 0;
`;

export const Container = styled.div`
  display: table;
  align-items: center;
  max-width: 1200px;
  width: 100%;
  margin: 0 auto;
  position: relative;

  @media (max-width: 1400px) {
    width: calc(100% - 4rem);
    margin-left: 2rem;
    margin-right: 2rem;
  }
`;

export const Heading = styled.div`
  display: table;
  width: 100%;
  margin: 0 auto;
  position: relative;
`;

export const StyledAccordionBody = styled(AccordionItemPanel)`
  width: 100%;
  padding: 2rem;
  animation: fadein 0.35s ease-in;

  @keyframes fadein {
    0% {
      opacity: 0;
    }

    100% {
      opacity: 1;
    }
  }

  p,
  a {
    font-size: 1rem;
    margin-bottom: 1rem;
    line-height: 1.5;
  }

  p {
    &:last-child {
      margin-bottom: 0;
    }
  }

  a {
    color: ${themeGet('colors.pc-red', '#E1251B')};

    &:hover,
    &:focus {
      color: ${themeGet('colors.copyGrey')};
      text-decoration: underline;
    }
  }
`;

export const AccordionWrapper = styled(Accordion)`
  display: table;
  width: 100%;
  max-width: 975px;
  margin: 0 auto;
  clear: both;
  border-top: 1px solid ${themeGet('colors.border-grey')};
  border-bottom: 1px solid ${themeGet('colors.border-grey')};
`;

export const StyledAccordionItem = styled(AccordionItem)`
  width: 100%;
  border-bottom: 1px solid ${themeGet('colors.lightGrey')};

  &:last-child {
    border-bottom: none;
  }
`;

export const StyledAccordionItemButton = styled(AccordionItemButton)`
  position: relative;
  padding: 1.5rem 0;
  text-align: center;
  margin: 0 auto;

  &[aria-expanded='false'] {
    p {
      &:after {
        content: '';
        box-sizing: border-box;
        height: 10px;
        width: 10px;
        border-style: solid;
        border-color: ${themeGet('colors.secondary-velvet')};
        border-width: 0px 2px 2px 0px;
        transform: rotate(45deg);
        top: 5px;
      }
    }
  }

  &[aria-expanded='true'] {
    p {
      &:after {
        content: '';
        box-sizing: border-box;
        height: 10px;
        width: 10px;
        border-style: solid;
        border-color: ${themeGet('colors.secondary-velvet')};
        border-width: 2px 0px 0px 2px;
        transform: rotate(45deg);
        top: 10px;
        /* transition: all 50ms ease-in-out; */
      }
    }
  }

  p {
    width: 100%;
    max-width: 250px;
    text-align: right;
    font-size: 1rem;
    color: ${themeGet('colors.secondary-velvet')};
    font-weight: ${themeGet('fontWeights.medium')};
    padding-right: 1.5rem;
    margin: 0 auto;
    position: relative;
    left: -6%;

    @media only screen and (max-width: ${themeGet('breakpoints.md')}) {
      left: -9%;
    }

    @media only screen and (max-width: 640px) {
      left: -16%;
    }

    &:after {
      position: absolute;
      right: 0;
    }
  }
`;

export const Title = styled.p`
  font-size: 1.4rem;
  margin-bottom: 0;
  color: ${themeGet('colors.pc-red', '#E1251B')};
`;

export const StyledAccordionItemTitle = styled(AccordionItemHeading)`
  width: 100%;
  cursor: pointer;
`;
